import capitalize from 'lodash.capitalize';
import pluralizeLib from 'pluralize';

import { Translator } from '../Translator';

const dashedCapitalized = (key) =>
  !!key ? key.split(/[ -]+/).map(capitalize).join('-') : '';
const dashedLowercased = (key) =>
  !!key ? key.replace(/ /g, '-').toLowerCase() : '';

const translateDuration = (hours, days = 0) => {
  const pluralize = (value, single, many) => (value === 1 ? single : many);
  const translate = (key, n, defaultValue) =>
    Translator.translate(
      `Experience.Duration.n${key}`,
      { n },
      true,
      defaultValue,
    );

  return [
    { value: days, unit: pluralize(days, 'Day', 'Days') },
    { value: hours, unit: pluralize(hours, 'Hour', 'Hours') },
  ]
    .reduce((result, { value, unit }) => {
      if (value) {
        result.push(translate(unit, value, `${value} ${unit.toLowerCase()}`));
      }
      return result;
    }, [])
    .join(' ');
};

const translateLanguage = (language, textOnly = false) =>
  Translator.translate(
    `Common.Languages.${dashedCapitalized(language)}`,
    {},
    textOnly,
    capitalize(language),
  );
const translateCity = (city, textOnly = false) =>
  Translator.translate(
    `Common.Cities.${dashedCapitalized(city)}`,
    {},
    textOnly,
    capitalize(city),
  );
const translateCountry = (country, textOnly = false) =>
  Translator.translate(
    `Common.Countries.${dashedCapitalized(country)}`,
    {},
    textOnly,
    capitalize(country),
  );
const translateSubcategoryOrTag = (tag, singular = false, textOnly = false) =>
  Translator.translate(
    `Experience.SubcategoryOrTag.${
      singular
        ? pluralizeLib(dashedLowercased(tag), 1)
        : pluralizeLib(dashedLowercased(tag), 2)
    }`,
    {},
    textOnly,
    capitalize(singular ? pluralizeLib(tag, 1) : pluralizeLib(tag, 2)),
  );
const translateCuisine = (tag) =>
  Translator.translate(
    `Experience.Cuisine.${dashedLowercased(tag)}`,
    {},
    false,
    capitalize(tag),
  );
const translateCovidText = (city) =>
  Translator.translate(
    `Common.Covid.${dashedCapitalized(city)}`,
    {},
    true,
    Translator.translate('Common.Covid.Default', {}, true, undefined),
  );

export {
  translateCountry,
  translateCity,
  translateLanguage,
  translateDuration,
  translateSubcategoryOrTag,
  translateCuisine,
  translateCovidText,
};
